<template>
    <div class="error">
        <p>Error</p>
    </div>
</template>

<script>
    export default {
        name: "Error"
    }
</script>

<style scoped>

</style>